

export default (state = {}, action) => {
  if (action.type == "SET_CONFIG") {
    return action.value;
  }
  return state;
};